"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("./styles");

function DarkText(props) {
  var className = props.className,
      fontSize = props.fontSize,
      fontSizeM = props.fontSizeM,
      fontSizeS = props.fontSizeS,
      color = props.color,
      uppercase = props.uppercase,
      letterSpacing = props.letterSpacing,
      bold = props.bold,
      as = props.as,
      rest = (0, _objectWithoutProperties2.default)(props, ["className", "fontSize", "fontSizeM", "fontSizeS", "color", "uppercase", "letterSpacing", "bold", "as"]);
  var AsComponent = as;
  return _react.default.createElement(AsComponent, (0, _extends2.default)({
    className: (0, _classnames.default)('dark-text', _styles.darkText, color, "font".concat(fontSize), letterSpacing === 'normal' ? 'letter-spacing-normal' : "letter-spacing-".concat(letterSpacing * 10), fontSizeM ? "m-font".concat(fontSizeM) : '', fontSizeS ? "s-font".concat(fontSizeS) : '', {
      uppercase: uppercase,
      bold: bold
    }, className)
  }, rest));
}

DarkText.propTypes = {
  className: _propTypes.default.string,
  uppercase: _propTypes.default.bool,
  letterSpacing: _propTypes.default.oneOf(['normal', 2, 0.1, 0.5, 1.5]),
  bold: _propTypes.default.bool,
  as: _propTypes.default.string,
  color: _propTypes.default.oneOf(['silver', 'copper', 'iron', 'sapphire', 'emerald', 'topaz', 'cobalt', 'white', 'ruby', 'amethyst', 'zinc', 'carbon', 'saturn']),
  fontSize: _propTypes.default.oneOf([10, 12, 14, 15, 16, 17, 18, 20, 24, 26, 30, 32, 44, 64]),
  fontSizeM: _propTypes.default.oneOf([10, 12, 14, 15, 16, 17, 18, 20, 24, 30, 32, 44, 64]),
  fontSizeS: _propTypes.default.oneOf([10, 12, 14, 15, 16, 17, 18, 20, 24, 30, 32, 44, 64])
};
DarkText.defaultProps = {
  className: '',
  fontSize: 16,
  fontSizeM: null,
  fontSizeS: null,
  color: 'silver',
  uppercase: false,
  bold: false,
  letterSpacing: 'normal',
  as: 'p'
};
var _default = DarkText;
exports.default = _default;